"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["label", "icon", "id", "onClick"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var getBoxShadow = function getBoxShadow(color) {
    return {
      '&:focus': {
        '-webkit-box-shadow': "inset 0 0 0 4px ".concat(color),
        'box-shadow': "inset 0 0 0 4px ".concat(color)
      }
    };
  };
  return {
    buttonRoot: _objectSpread({}, getBoxShadow(theme.palette.opacity.primary[800][38])),
    iconLarge: {
      height: theme.spacing(3),
      width: theme.spacing(3)
    },
    iconOnly: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },
    iconSmall: {
      height: theme.spacing(2),
      marginRight: theme.spacing(0.5),
      width: theme.spacing(2)
    },
    primaryButtonContained: _objectSpread({
      borderLeft: '1px solid white'
    }, getBoxShadow(theme.palette.opacity.white[38]))
  };
});
var defaultProps = {
  'aria-label': 'Button Group',
  dataMetrics: {
    root: 'fuse_button_group'
  },
  disabled: false,
  mode: 'standard',
  selectedButtons: [],
  size: 'medium'
};

/**
 * A ButtonGroup is a group of buttons with related actions. It's primary
 * purpose is to keep frequently used actions grouped together. The button group
 * utilizes only the secondary outline style.
 */
var ButtonGroup = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var ariaLabel = props['aria-label'],
    buttonProps = props.buttonProps,
    className = props.className,
    dataMetrics = props.dataMetrics,
    disabled = props.disabled,
    mode = props.mode,
    selectedButtons = props.selectedButtons,
    size = props.size;
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var styles = useStyles();
  var _React$useState = _react["default"].useState(selectedButtons),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    selected = _React$useState2[0],
    setSelected = _React$useState2[1];
  (0, _react.useEffect)(function () {
    setSelected(selectedButtons);
  }, [selectedButtons]);
  var buttonRefs = buttonProps.map(function () {
    return /*#__PURE__*/(0, _react.createRef)();
  });
  return /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
    "aria-label": ariaLabel,
    color: "primary",
    className: className,
    classes: {
      grouped: styles.buttonRoot
    },
    "data-metrics": mergedDataMetrics.root,
    disabled: disabled,
    disableRipple: true,
    disableFocusRipple: true,
    ref: ref,
    size: size
  }, buttonProps.map(function (_ref, idx, arr) {
    var label = _ref.label,
      icon = _ref.icon,
      id = _ref.id,
      onClick = _ref.onClick,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    var iconOnly = !label;
    var isSelected = selected.includes(id);
    var prevSelected = idx === 0 ? false : selected.includes(arr[idx - 1].id);
    var iconComponent = icon ? /*#__PURE__*/_react["default"].cloneElement(icon, {
      className: (0, _classnames["default"])(icon.props.className, label ? styles.iconSmall : styles.iconLarge)
    }) : null;
    var onButtonClick = function onButtonClick(e, buttonId) {
      onClick(e, buttonId);
      if (mode === 'radio') {
        setSelected([buttonId]);
      } else if (mode === 'checkbox') {
        if (isSelected) {
          setSelected(function (prev) {
            return prev.filter(function (_id) {
              return _id !== buttonId;
            });
          });
        } else {
          setSelected(function (prev) {
            return [].concat((0, _toConsumableArray2["default"])(prev), [buttonId]);
          });
        }
      }
    };
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
      className: isSelected && prevSelected ? styles.primaryButtonContained : undefined,
      classes: {
        outlined: iconOnly && styles.iconOnly
      },
      key: id,
      onClick: function onClick(e) {
        return onButtonClick(e, id);
      },
      icon: label && iconComponent,
      iconPosition: "left",
      ref: buttonRefs[idx],
      variant: isSelected ? 'contained' : 'outlined',
      onKeyUp: function onKeyUp(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          if (idx > 0) {
            buttonRefs[idx - 1].current.focus();
          }
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          if (idx < arr.length - 1) {
            buttonRefs[idx + 1].current.focus();
          }
        }
      },
      size: size
    }, rest), label || iconComponent);
  }));
});
ButtonGroup.defaultProps = defaultProps;
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The aria-label to pass to the ButtonGroup component.
   */
  'aria-label': _propTypes["default"].string,
  /**
   * Props to pass to the buttons in the button group.
   * The min number of buttons is **2** and the **max is 5**.
   *
   * > `icon: node `<br>
   * > `id: string | number` - **required** <br>
   * > `label: string` <br>
   * > `onClick: func` - **required**
   */
  buttonProps: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    icon: _propTypes["default"].node,
    id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    label: _propTypes["default"].string,
    onClick: _propTypes["default"].func.isRequired
  })).isRequired,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If `true`, the ButtonGroup will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * The mode to pass to the ButtonGroup.
   */
  mode: _propTypes["default"].oneOf(['checkbox', 'radio', 'standard']),
  /**
   * An array of initially selected buttons. Should only be used with
   * checkbox or radio mode.
   */
  selectedButtons: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  /**
   * The size of the buttons in the ButtonGroup.
   */
  size: _propTypes["default"].oneOf(['small', 'medium'])
} : {};
var _default = ButtonGroup;
exports["default"] = _default;